module.exports = __webpack_public_path__ + "img/Vue.9741e627.jpg";